import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Stack,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

import { insightsAccordionTitleSx } from "./insightsComponentSx";

export default function DesignAccordion({
  title,
  subtitle,
  expanded,
  onChange,
  onEntered,
  children,
  className,
  disableGutters = true,
}) {
  return (
    <Accordion
      className={className}
      expanded={expanded}
      onChange={(_, isExpanded) => onChange(isExpanded)}
      disableGutters={disableGutters}
      TransitionProps={onEntered ? { onEntered } : undefined}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
          <Typography component="span" sx={insightsAccordionTitleSx()}>
            {title}
          </Typography>
          {subtitle ? (
            <Typography component="span" variant="body2" color="text.secondary">
              {subtitle}
            </Typography>
          ) : null}
        </Stack>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
}

DesignAccordion.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  expanded: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onEntered: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  disableGutters: PropTypes.bool,
};
